import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  arrow: {
    display: 'flex',
    justifyContent: 'center',
  },
  icon: {
    cursor: 'pointer',
  },
}));
